module.exports = __webpack_public_path__ + "img/bottom-line.efb2294d.png";